'use client';
var classes = {"root":"m_bf2d988c","inner":"m_26062bec","input":"m_26063560","icon":"m_bf295423","input--outline":"m_215c4542"};

export { classes as default };
//# sourceMappingURL=Checkbox.module.css.mjs.map
